import { render, staticRenderFns } from "./GLASubsidiary.vue?vue&type=template&id=1e0d7df1&scoped=true&"
import script from "./GLASubsidiary.vue?vue&type=script&lang=js&"
export * from "./GLASubsidiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0d7df1",
  null
  
)

export default component.exports